// Language & currency popup (WPML + WooCommerce Multilingual)

function closeAllSelects(popup, except) {
    popup.querySelectorAll('[data-lang-select]').forEach((select) => {
        if (select === except) return;
        select.querySelector('.lang-select__toggle').setAttribute('aria-expanded', 'false');
        select.querySelector('.lang-select__list').hidden = true;
    });
}

function initSelect(popup, select) {
    const toggle = select.querySelector('.lang-select__toggle');
    const list = select.querySelector('.lang-select__list');
    const input = select.querySelector('input[type="hidden"]');

    toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        closeAllSelects(popup, select);
        toggle.setAttribute('aria-expanded', String(open));
        list.hidden = !open;
        if (open) {
            (list.querySelector('[aria-selected="true"]') || list.firstElementChild)?.focus();
        }
    });

    const choose = (option) => {
        list.querySelectorAll('.lang-select__option').forEach((o) => o.setAttribute('aria-selected', 'false'));
        option.setAttribute('aria-selected', 'true');
        input.value = option.dataset.value;
        select.querySelector('[data-lang-select-icon]').innerHTML = option.querySelector('.lang-select__icon').innerHTML;
        select.querySelector('[data-lang-select-label]').textContent = option.querySelector('.lang-select__label').textContent;
        toggle.setAttribute('aria-expanded', 'false');
        list.hidden = true;
        toggle.focus();
    };

    list.addEventListener('click', (e) => {
        const option = e.target.closest('.lang-select__option');
        if (option) choose(option);
    });

    list.addEventListener('keydown', (e) => {
        const option = e.target.closest('.lang-select__option');
        if (!option) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            choose(option);
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            option.nextElementSibling?.focus();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            option.previousElementSibling?.focus();
        }
    });
}

function init() {
    const popup = document.getElementById('lang-popup');
    if (!popup) return;

    let lastTrigger = null;

    const open = (trigger) => {
        lastTrigger = trigger;
        popup.hidden = false;
        document.body.style.overflow = 'hidden';
        popup.querySelector('.lang-select__toggle')?.focus();
    };

    const close = () => {
        closeAllSelects(popup);
        popup.hidden = true;
        document.body.style.overflow = '';
        lastTrigger?.focus();
    };

    document.querySelectorAll('[data-lang-popup-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            open(btn);
        });
    });

    popup.querySelectorAll('[data-lang-popup-close]').forEach((el) => el.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !popup.hidden) close();
    });

    popup.addEventListener('click', (e) => {
        if (!e.target.closest('[data-lang-select]')) closeAllSelects(popup);
    });

    popup.querySelectorAll('[data-lang-select]').forEach((select) => initSelect(popup, select));

    popup.querySelector('[data-lang-popup-form]').addEventListener('submit', (e) => {
        e.preventDefault();

        const langOption = popup.querySelector('[data-lang-select="language"] [aria-selected="true"]');
        const currency = popup.querySelector('input[name="currency"]').value;

        // URL bieżącej strony w wybranym języku (z WPML), fallback: aktualny URL
        const url = new URL(langOption?.dataset.url || window.location.href, window.location.origin);

        // WCML przełącza walutę klienta na podstawie parametru ?wcmlc=
        if (currency) {
            url.searchParams.set('wcmlc', currency);
        }

        window.location.href = url.toString();
    });
}

export default { init };
